import styled from 'styled-components';

const StyledTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 250px;
`;

const StyledTooltipBorder = styled.div`
  border: 1px solid #c6c6c6;
`;

const StyledTooltipTitle = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  padding: 5px;
  word-break: break-word;
`;

const StyledTooltipContent = styled.div`
  text-align: left;
  font-size: 12px;
  padding: 5px;
`;

export {
  StyledTooltipContainer,
  StyledTooltipBorder,
  StyledTooltipTitle,
  StyledTooltipContent
};
